import { render } from "./TextStylePanel.vue?vue&type=template&id=43fccffc&scoped=true&ts=true"
import script from "./TextStylePanel.vue?vue&type=script&lang=ts"
export * from "./TextStylePanel.vue?vue&type=script&lang=ts"

import "./TextStylePanel.vue?vue&type=style&index=0&id=43fccffc&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fccffc"]])

export default __exports__